import React from 'react';
export function HeroImage() {
  return <section className="w-full" data-id="element-8">
      <img src="https://cdn.shopify.com/s/files/1/1019/9361/1596/files/hf_20260305_184815_6d262935-621e-4246-bb35-cab8b0ce60f2.jpg?v=1772970714" alt="Biohacking y Alimentación Consciente" className="w-full block" data-id="element-9" />
    </section>;
}